import { Carrier, Data, RateAdvisor, Utils } from 'common';
import React from 'react';

const { ManageCarrier } = Carrier;
const { AllCarriers } = Data;
const { Session, Util } = Utils;
const { CarrierServices } = RateAdvisor;

const completionCallback = (success, carrier) => {
	const { AllowedTargetOrigin } = Session.getSettings();
	const carrierData = AllCarriers.find(({ value }) => value === carrier) || {};

	if (Session.getSettings().IsInWinClient) {
		window.close();
	} else if (success) {
		try {
			// clear carrier services cache to ensure new carrier services are loaded
			CarrierServices.clearCache();
			// return "carrier" key to be consistent with the data sent before changing to Session V2.
			Util.postMessage(
				{ type: 'Carrier', success: true, carrier: carrierData.key },
				AllowedTargetOrigin
			);
		} catch (error) {
			console.log(error);
		}
	}
};

const ManageCarrierWrapper = ({ hasHeader }) => (
	<div className="manage-carrier-with-header">
		{hasHeader && <h1 className="carrier-header">Manage Carrier</h1>}
		<ManageCarrier addCarrierCallback={completionCallback} />
	</div>
);

export default ManageCarrierWrapper;
